module.exports = __webpack_public_path__ + "static/media/NSCA_CPT2.83629401.jpg";